export interface TimelineItemWebComponentSchema {
  // all the data needed for rendering
  alertTitle: string;
  severity: number;
  severityColor: string | undefined;
  killChainPhases?: KillChainPhases;
  alertDescription: string;
  sensor: string;
  classIcon?: string | null;
  identicalTactic: number;
  numberOfEndpoints?: number;
  numberOfServers?: number;
  numberOfInternalEmails?: number;
  numberOfIps?: number;
  numberOfIdentities?: number;
}

export enum KillChainPhases {
  INITIAL_ACCESS = 1,
  EXECUTION = 2,
  PERSISTENCE = 3,
  PRIVILEGE_ESALATION = 4,
  DEFENCE_EVASION = 5,
  CREDENTIAL_ACCESS = 6,
  DISCOVERY = 7,
  LATERAL_MOVEMENT = 8,
  COLLECTION = 9,
  COMMAND_AND_CONTROL = 10,
  EXFILTRATION = 11,
  IMPACT = 12,
}

export enum SeverityScores {
  SEVERITY_LOW = 1,
  SEVERITY_MEDIUM = 2,
  SEVERITY_HIGH = 3,
}

export enum SeverityColors {
  SEVERITY_LOW = '#FFB74D',
  SEVERITY_MEDIUM = '#F57C00',
  SEVERITY_HIGH = '#D23138',
}

export const OPEN_OTHER_ALERTS_EVENT_NAME = 'timeline-open-other-alerts';
